module.exports = __webpack_public_path__ + "41fb4ba395de940217fdbe9399e1cbeb.jpg";